/* These lines of code are defining constants in JavaScript using the `export const` syntax. */
export const GET_ALL_PRODUCTS_REQUEST = 'GET_ALL_PRODUCTS_REQUEST';
export const GET_ALL_PRODUCTS_SUCCESS = 'GET_ALL_PRODUCTS_SUCCESS';
export const SET_SELECTED_PRODUCT = 'SET_SELECTED_PRODUCT';
export const SET_FILTER_DATA = 'SET_FILTER_DATA';
export const LOADING_FILTER_DATA = 'LOADING_FILTER_DATA';
